import React, { useEffect, useState } from 'react';
import { Routes, Route, NavLink, useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import NotificationBell from '../components/NotificationBell';
import LiveDot from '../components/LiveDot';
import AccountSwitcher from '../components/AccountSwitcher';
import Icon from '../components/Icons';
import VerificationBanner from '../components/VerificationBanner';
import TraderDownBanner from '../components/TraderDownBanner';
import Overview from '../views/copier/Overview';
import FindTraders from '../views/copier/FindTraders';
import MyTraders from '../views/copier/MyTraders';
import CopiedTrades from '../views/copier/CopiedTrades';
// PROFIT-SHARE BILLING — TEMPORARILY DISABLED (2026-08-19)
// import Billing from '../views/copier/Billing';
import Settings from '../views/shared/Settings';
import Accounts from '../views/shared/Accounts';

const NAV = [
  { to: '/copier',           end: true, icon: 'overview', label: 'Overview' },
  { to: '/copier/find',      icon: 'find',    label: 'Find Traders' },
  { to: '/copier/my-traders', icon: 'users',  label: 'My Traders' },
  { to: '/copier/history',   icon: 'copy',    label: 'Copied Trades' },
  // PROFIT-SHARE BILLING — TEMPORARILY DISABLED (2026-08-19); see worker.js
  // { to: '/copier/billing',   icon: 'history', label: 'Billing' },
  { to: '/copier/accounts',  icon: 'users',   label: 'MT5 Accounts' },
  { to: '/copier/settings',  icon: 'user',    label: 'Settings' },
];

export default function CopierLayout() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [sidebarOpen, setSidebarOpen] = useState(false);

  useEffect(() => { setSidebarOpen(false); }, [location.pathname]);

  async function handleLogout() {
    await logout();
    navigate('/login');
  }

  return (
    <div className={`wrapper ${sidebarOpen ? 'sidebar-open' : ''}`}>
      {sidebarOpen && <div className="sidebar-backdrop" onClick={() => setSidebarOpen(false)} />}

      <div className="sidebar" data-color="black">
        <div className="sidebar-wrapper">
          <div className="logo">
            <span className="simple-text">CopyTrade</span>
            <div className="logo-sub" style={{
              fontSize: 11, color: 'var(--text-tertiary)',
              textTransform: 'uppercase', letterSpacing: '0.08em', marginTop: 4,
            }}>Copier</div>
            <button
              className="sidebar-close"
              onClick={() => setSidebarOpen(false)}
              aria-label="Close menu"
            >
              <Icon name="close" size={20} />
            </button>
          </div>
          <ul className="nav">
            {NAV.map(item => (
              <li key={item.to}>
                <NavLink to={item.to} end={item.end}>
                  <Icon name={item.icon} size={18} className="nav-icon" />
                  <p>{item.label}</p>
                </NavLink>
              </li>
            ))}
          </ul>
        </div>
      </div>

      <div className="main-panel">
        <nav className="navbar navbar-expand-lg navbar-absolute navbar-transparent">
          <div className="container-fluid">
            <button
              className="navbar-toggle"
              onClick={() => setSidebarOpen(v => !v)}
              aria-label="Open menu"
            >
              <Icon name="menu" size={22} />
            </button>
            <div className="navbar-wrapper">
              <div className="navbar-brand">
                <span className="navbar-brand-full">CopyTrade — Copier</span>
                <span className="navbar-brand-short">Copier</span>
              </div>
            </div>
            <div className="navbar-nav ml-auto">
              <AccountSwitcher />
              <LiveDot />
              <NotificationBell />
              <span className="nav-link text-white user-email">
                <Icon name="user" size={14} className="mr-1" />
                <span className="d-none d-md-inline">{user?.username || user?.email}</span>
              </span>
              <button
                className="btn btn-sm btn-outline-secondary ml-2 logout-btn"
                onClick={handleLogout}
                aria-label="Logout"
              >
                <Icon name="logout" size={14} />
                <span className="d-none d-sm-inline ml-1">Logout</span>
              </button>
            </div>
          </div>
        </nav>

        <div className="content">
          <VerificationBanner user={user} />
          <TraderDownBanner />
          <Routes>
            <Route path="/"           element={<Overview />} />
            <Route path="/find"       element={<FindTraders />} />
            <Route path="/my-traders" element={<MyTraders />} />
            <Route path="/history"    element={<CopiedTrades />} />
            {/* PROFIT-SHARE BILLING — TEMPORARILY DISABLED (2026-08-19) */}
            {/* <Route path="/billing"    element={<Billing />} /> */}
            <Route path="/accounts"   element={<Accounts />} />
            <Route path="/settings"   element={<Settings />} />
          </Routes>
        </div>
      </div>
    </div>
  );
}
